<!-- This nav gives you links to click, which tells the router which route to use (defined in the routes constant in  AppRoutingModule) -->
<nav *ngIf="this.appData.userId !== undefined">
  <ul>
  	<li *ngIf="this.appData.availablePrivileges.value.CREATE_COMPANY">
  		<button  mat-button routerLink="/dashboard">Dashboard</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.VIEW_COMPANY">
  		<button mat-button routerLink="/eduSys-view">Educational System View</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.CREATE_COMPANY">
  		<button mat-button routerLink="/eduSys-create">Education System Create</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.VIEW_INDIVIDUAL">
  		<button mat-button routerLink="/individual-view">Individual System View</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.CREATE_INDIVIDUAL">
  		<button mat-button routerLink="/individual-create">Individual System Create</button>
  	</li>
  	<li *ngIf="this.appData.userId === 'Admin' || this.appData.availablePrivileges.value.CREATE_TEST_SERIES ">
		<button mat-button routerLink="/test-prepare-question">Prepare Test Questions</button>
    </li>
  	<!--<li *ngIf="this.appData.availablePrivileges.value.VIEW_TEST_SERIES || this.appData.availablePrivileges.value.CREATE_TEST_SERIES ||  this.appData.availablePrivileges.value.INTERVIEW_TEST">
  		<button mat-button routerLink="/dashboard-test-series">Test Series</button>
  	</li>-->
  	<li *ngIf="this.appData.availablePrivileges.value.VIEW_TEST_SERIES || this.appData.availablePrivileges.value.CREATE_TEST_SERIES ||  this.appData.availablePrivileges.value.INTERVIEW_TEST">
  		<button mat-button routerLink="/test-instructions">Test Series</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.VIEW_OTHERS_TEST || this.appData.availablePrivileges.value.VIEW_OTHERS_TEST_WITH_RESULT">
  		<button mat-button routerLink="/test-history">View Test Results History</button>
  	</li>
  	<li *ngIf="this.appData.userId === 'Admin'">
  		<button mat-button routerLink="/test-series-comp-sub-mapping">Test Series Competition Subject Mapping</button>
  	</li>
  	<li *ngIf="this.appData.availablePrivileges.value.VIDEO_CONFIG">
  		<button mat-button routerLink="/video-config">Configure Video</button>
  	</li>
<!--   	<li>
  		<button mat-button [matMenuTriggerFor]="afterMenu" routerLink="/eduSys-view">Educational System View</button>
  	</li>
  	<li>
  		<button mat-button [matMenuTriggerFor]="afterMenu" routerLink="/eduSys-view">Educational System View</button>
  	</li>
  	<li>
  		<button mat-button [matMenuTriggerFor]="afterMenu" routerLink="/eduSys-view">Educational System View</button>
  	</li> -->
  	
    <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/dashboard-test-series" routerLinkActive="active">Test Series</a>
    </li>
     <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/test-prepare-question" routerLinkActive="active">Prepare Test Questions</a>
    </li>
     <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/test-instructions" routerLinkActive="active">Test Instructions</a>
    </li>
    <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/test-dashboard" routerLinkActive="active">Test Dashboard Component</a>
    </li>
    <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/changePassword" routerLinkActive="active">Change Password Page Component</a>
    </li>
    <li *ngIf="this.appData.userId === 'Admin'">
    	<a routerLink="/r-home" routerLinkActive="active">Redirect Home Component</a>
    </li>
  </ul>
</nav>

